import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SelectionDTO } from '@/features/admin/selections/dtos/selection';

import { Modal } from '@/ui/modals';
import { Button } from '@/ui/Button';
import PageTitle from "@/components/shared/utillities/PageTitle";

interface IProps {
    selection?: SelectionDTO;
}

const ApplicationClosedWarningModal = observer(({ selection }: IProps) => {
    const { t } = useTranslation();
    const [closed, setClosed] = React.useState(false);

    return (
        <Modal
            open={selection && !selection.isOpened && !closed}
            disableScrollArea
            closeButton={
                <Button onClick={() => setClosed(true)}>
                    {t('buttons.close')}
                </Button>
            }
        >
            <div className="mt-10">
                <PageTitle>{t('application.isClosedTitle')}</PageTitle>
            </div>
            <div className="mb-6 mt-6">
                {t('application.isClosedInfo')}
            </div>
        </Modal>
    );
});

export { ApplicationClosedWarningModal };
